/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateSimcardDto } from '../../models/create-simcard-dto';
import { SimcardCreationResponse } from '../../models/simcard-creation-response';

export interface CreateSimcard$Params {
      body?: CreateSimcardDto
}

export function createSimcard(http: HttpClient, rootUrl: string, params?: CreateSimcard$Params, context?: HttpContext): Observable<StrictHttpResponse<SimcardCreationResponse>> {
  const rb = new RequestBuilder(rootUrl, createSimcard.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SimcardCreationResponse>;
    })
  );
}

createSimcard.PATH = '/sim';
